import { FeatureFlag } from '@web/common';
import { isLocalOrDev } from '../../config/environment';

export function isFeatureEnabled(flag: FeatureFlag): boolean {
  return isLocalOrDev || process.env[flag] === 'true';
}
